import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  cdkSubscriptionStatuses,
  isEligibleForCDKTrial,
  pages,
} from "../../../constants";
import SimpleTransitionBoth from "../../Utility/SimpleTransitionBoth";
import { Strikethrough } from "../../Utility/Strikethrough";
import { FAQAccordion } from "../../Utility/FAQAccordion";
import Truck_Icon from "./images/Truck_Icon_4_2_edited.png";
import { HelmetUtil } from "../../Utility/HelmetUtil";
import { determineHasAccessToCDKFeatures } from "../../../helpers/utilities";
import { DiliTextCP } from "../../Utility/DiliTextCP";

const notes = {
  standardRates: {
    number: "1",
    explanation:
      "Standard rate of $600 per month is applied beginning your second month. The charge will be applied to your invoice, divided according to your billing cycle.",
  },
  sharing: {
    number: "2",
    explanation:
      "If you choose not to share certain orders with us through the ShipVia filter option, Diligent shall only process those orders that do not meet the criteria set enough to determine so. New orders that do not meet the criteria will not be stored.",
  },
  pullFrequency: {
    number: "3",
    explanation:
      "Closed orders will be pulled once every 16 minutes, during business hours.",
  },
  cancellation: {
    number: "4",
    explanation:
      "You will continue to have access to CDK features until the end of your current month.",
  },
};

const CDKFAQs = [
  {
    question: "How does it work?",
    answer: (
      <>
        We will continuously pull your closed orders directly from CDK
        <sup>{notes.pullFrequency.number}</sup>, and they will automatically
        appear in our system. You'll be able to see all of them on our new CDK
        Order Import page. Verify everything looks correct and hit finalize!
      </>
    ),
  },
  {
    question: "Who is this for?",
    answer:
      "The Diligent CDK Integration is for you if you use CDK as your main dealership system.",
  },

  {
    question: "How much does it cost?",
    answer:
      "First time subscribers enjoy their initial month for free! After that you'll be charged $600 per month.",
  },
  {
    question: "How does the billing process work?",
    answer:
      "We will add the subscription charge to your invoice. It will be divided according to your billing cycle. For example, if you are billed monthly, the subscription fee will be listed as a $600 dollar charge on the month's invoice. If you are billed semi-monthly it will be listed as a $200 charge on each of the month's invoices, and so on. ",
  },
  {
    question: "What if we need to cancel?",
    // ***If a client
    // cancels much earlier, we may want to make a sort of queue table that
    // will email us a notification closer to the date we want to cancel. Also
    // cancellations involve Diligent creating a CDK Service Connect ticket and
    // need to confirm how long the wait is.
    answer: (
      <>
        Cancel any time during your initial free month (first time subscribers
        only). Then, you'll be able to cancel any time with thirty days' notice
        after a three-month term.
        <sup>{notes.cancellation.number}</sup> If you decide the CDK Integration
        isn't for you, or want to take a break, you can cancel your subscription
        at any time. If you would like to avoid being billed for the following
        month, please provide thirty-day notice. You may cancel through the
        'Manage Subscription' section on your client profile page.
      </>
    ),
  },
];

//animation delays in miliseconds
const title1Delay = 200;
const title1Duration = ".9s";
const title2Delay = 1100;
const title2Duration = "1s";
// const leadTextDelay = title2Delay + title2Duration + 200; TODO: make utility functions to convert between integers and the syntax necessary for the css. i.e. 250ms or 2.5s > 250 and back: 250 > 2.5s or 250ms
const leadTextDelay = 2300;
const leadTextDuration = "1s";
// const cardDelay = title2Delay + title2Duration + 200;
const cardDelay = 2300;
const cardDuration = "1s";
const everythingElseDelay = 2300;
const everythingElseDuration = "1s";
//Make absolute position sheared light gray div behind first section.
//Another section with diligent blue color. Contains a few pictures and text explaining/showing the integration, then a FAQ (no spaces between faq accordions)
//Conclusion and another get started button at the end of the page.
//Once they click get started, multi step form:
//step 1: Instructions on how to set things up.
//step 2 or 3: possibly a form if we need to collect data
//step 2 or 3: Terms and Agreements scrollview they have to scroll to the bottom to agree and continue.
//final step: Great!, you're ready to do the final step, instructions on what to do on CDK's website, once that's done your CDK integration will be enabled within 2?(TODO how many days) business days, Link to CDK website.
export const CDKPromoPage2 = ({ decodedJWT, cdkSubscriptionStatus }) => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    // console.log(decodedJWT);
    if (determineHasAccessToCDKFeatures(cdkSubscriptionStatus)) {
      history.replace(pages.cdkOrderImport.url);
    }
    if (cdkSubscriptionStatus === cdkSubscriptionStatuses.pending) {
      history.replace(pages.cdkSignUp.url);
    }
    // if (decodedJWT?.IsCdkClient) {
    //   history.push(pages.cdkOrderImport.url);
    // }
    //if we wanted to prevent scrolling till our intro animations are done,
    // window.onscroll = (e) => {
    //   window.scrollTo(0, 0);
    // };
    // setTimeout(() => {
    //   window.onscroll = () => {};
    // }, everythingElseDelay);
  }, [decodedJWT, cdkSubscriptionStatus]);

  // const [startedSignupProcess, setStartedSignupProcess] = useState(false);
  const handleClickGetStarted = () => {
    history.push("cdk-signup");
    // setStartedSignupProcess(true);
  };

  // const [showTermsModal, setShowTermsModal] = useState(false);

  // const handleOpenTermsModal = () => {
  //   setShowTermsModal(true);
  // };
  // const handleCloseTermsModal = () => {
  //   setShowTermsModal(false);
  // };
  const [design, setDesign] = useState(1);
  const handleChangeDesign = (event) => {
    setDesign(parseInt(event.target.value));
  };
  return (
    <>
      {/* <div style={{ position: "absolute", top: 100, left: 30, zIndex: 10000 }}>
        <DiliTextCP type="select" onChange={handleChangeDesign}>
          <option value={1}>Original</option>
          <option value={2}>Pricing Chart</option>
          <option value={3}>Cards</option>
          <option value={3}>Div Chart</option>
        </DiliTextCP>
      </div> */}
      <HelmetUtil title="CDK Intro" />
      <div className="remove-global-padding">
        <section
          className="cdk-shear-overlap-container p-3 pb-5"
          // style={{ marginBottom: "-20px" }}
        >
          <div className="cdk-shear-overlap"></div>
          <div className="mb-5">
            <h2 className="text-center">
              <SimpleTransitionBoth
                delay={title1Delay}
                duration={title1Duration}
                transitionBaseStyle={{
                  opacity: 0,
                  transform: "translateY(-30px)",
                }}
                transitionEndStyle={{
                  opacity: 1,
                  transform: "translateY(0px)",
                }}
              >
                Introducing
              </SimpleTransitionBoth>
              <SimpleTransitionBoth
                duration={title2Duration}
                delay={title2Delay}
                transitionBaseStyle={{
                  opacity: 0,
                  transform: "translateY(30px)",
                }}
                transitionEndStyle={{
                  opacity: 1,
                  transform: "translateY(0px)",
                }}
              >
                Diligent's CDK Integration
              </SimpleTransitionBoth>
            </h2>
          </div>
          <div className="row m-auto">
            <div className="col-md-6 pl-sm-5 px-xl-5 mb-5 mb-md-0">
              <div className="pl-sm-5 px-xl-5">
                <SimpleTransitionBoth
                  delay={leadTextDelay}
                  duration={leadTextDuration}
                  transitionBaseStyle={{
                    opacity: 0,
                    transform: "translateX(-30px)",
                  }}
                  transitionEndStyle={{
                    opacity: 1,
                    transform: "translateX(0px)",
                  }}
                >
                  <h3>
                    Your Orders.{" "}
                    <span className="text-dil-blue">Your Deliveries.</span>
                  </h3>
                  <p className="lead row col-xl-8">
                    Diligent's CDK Integration is here.
                    <br /> Place your orders in one system and find them on the
                    Diligent Client Portal.{" "}
                  </p>
                </SimpleTransitionBoth>
              </div>
            </div>
            <div
              className="col-md-6"
              style={{ display: "grid", placeContent: "center" }}
            >
              <SimpleTransitionBoth
                delay={cardDelay}
                duration={cardDuration}
                transitionBaseStyle={{
                  opacity: 0,
                  transform: "translateY(30px)",
                }}
                transitionEndStyle={{
                  opacity: 1,
                  transform: "translateX(0px)",
                }}
              >
                {design === 1 && (
                  <div
                    className="card paper-card text-center border-0"
                    style={{
                      width: "20rem",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: "20rem",
                        height: "13rem",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        className="card-img-top"
                        src={Truck_Icon}
                        alt="A delivery truck with data, represented by circuits, flowing into it."
                        style={{
                          // transform: "translateY(0px)",
                          width: "20rem",
                          // height: "13rem",
                          // backgroundColor: "gray",
                        }}
                      />
                    </div>
                    <div className="card-body pb-0">
                      <h5 className="card-title font-600">
                        {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                          <Strikethrough
                            containerStyle={{
                              // padding: "0px 20px 0px 20px",
                              display: "inline-block",
                              marginLeft: "-5px",
                            }}
                            containerClass="mb-1"
                            rotation="17"
                            widthAdd={15}
                            flip
                          >
                            $600
                          </Strikethrough>
                        ) : (
                          <div
                            style={{
                              display: "inline-block",
                              marginLeft: "-5px",
                            }}
                            className="mb-1"
                          >
                            $600
                          </div>
                        )}
                        <br />
                        CDK
                        <br />
                        Monthly
                        <br />
                        Subscription
                      </h5>
                      <p className="card-text pb-1">
                        {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                          <>
                            Your first month FREE
                            <br />
                          </>
                        ) : (
                          ""
                        )}
                        Spend less time entering data, and more time shipping.
                      </p>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleClickGetStarted}
                      >
                        Get Started
                      </button>
                      <p className="text-note mt-2 px-5">
                        {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                          <>
                            Standard rates apply after first month.
                            <sup>{notes.standardRates.number}</sup>
                          </>
                        ) : (
                          <div className="p-2"></div>
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {design === 2 && (
                  <table
                    className="paper-card text-center border-0"
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      backgroundColor: "white",
                    }}
                  >
                    <thead>
                      <tr style={{ borderBottom: "2px solid #ddd" }}>
                        <th scope="col" style={{ padding: 0 }}>
                          <div
                            style={{
                              width: "20rem",
                              height: "13rem",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              className="card-img-top"
                              src={Truck_Icon}
                              alt="A delivery truck with data, represented by circuits, flowing into it."
                              style={{
                                // transform: "translateY(0px)",
                                width: "20rem",
                                // height: "13rem",
                                // backgroundColor: "gray",
                              }}
                            />
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="cdk-pricing-chart-header cdk-pricing-chart-cell cdk-pricing-chart-top-header"
                        >
                          Closed Orders
                        </th>
                        <th
                          scope="col"
                          className="cdk-pricing-chart-header cdk-pricing-chart-cell cdk-pricing-chart-top-header"
                        >
                          Closed + Open Orders
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="list-border-bottom">
                        <td>
                          <div className="cdk-pricing-chart-header cdk-pricing-chart-left-header cdk-pricing-chart-cell">
                            Base Charge Per Month
                          </div>
                        </td>
                        <td className="cdk-pricing-chart-cell">$600</td>
                        <td className="cdk-pricing-chart-cell">$1,400</td>
                      </tr>
                      <tr className="list-border-bottom">
                        <td className="cdk-pricing-chart-header cdk-pricing-chart-left-header cdk-pricing-chart-cell">
                          Transactions Covered
                        </td>
                        <td className="cdk-pricing-chart-cell">Unlimited</td>
                        <td className="cdk-pricing-chart-cell">30,000</td>
                      </tr>
                      <tr className="list-border-bottom">
                        <td className="cdk-pricing-chart-header cdk-pricing-chart-left-header cdk-pricing-chart-cell">
                          Additional Transaction Charge
                        </td>
                        <td className="cdk-pricing-chart-cell">N/A</td>
                        <td className="cdk-pricing-chart-cell">
                          $0.06 per transaction
                        </td>
                      </tr>
                      <tr className="list-border-bottom">
                        <td className="cdk-pricing-chart-header cdk-pricing-chart-left-header cdk-pricing-chart-cell">
                          Who is this for?
                        </td>
                        <td className="cdk-pricing-chart-cell">
                          If you want to find your orders in our system once you
                          close them in yours, without having to re-enter
                          everything!
                        </td>
                        <td className="cdk-pricing-chart-cell">
                          If you need your orders in our system before they are
                          closed in yours, such as in the case your business
                          does not close COD orders until after delivery and
                          payment is received - in addition to your closed
                          orders.
                        </td>
                      </tr>
                      <tr className="list-border-bottom">
                        <td className="cdk-pricing-chart-header cdk-pricing-chart-left-header cdk-pricing-chart-cell">
                          What counts as a transaction?
                        </td>
                        <td className="cdk-pricing-chart-cell">
                          Any time you close an order in your system.
                        </td>
                        <td className="cdk-pricing-chart-cell">
                          Any action applied to an order before it is closed may
                          result in a transaction.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {design === 3 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "2rem",
                    }}
                  >
                    <div
                      className="card paper-card cdk-card text-center border-0"
                      style={{
                        width: "20rem",
                        borderRadius: "12px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "20rem",
                          height: "13rem",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "grid",
                            placeContent: "center",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1.7rem",
                            textShadow: "0px 0px 5px black",
                            backgroundColor: "rgb(0,0,0,.3)",
                          }}
                        >
                          CDK Base
                        </div>
                        <img
                          className="card-img-top"
                          src={Truck_Icon}
                          alt="A delivery truck with data, represented by circuits, flowing into it."
                          style={{
                            // transform: "translateY(0px)",
                            width: "20rem",
                            // height: "13rem",
                            // backgroundColor: "gray",
                          }}
                        />
                      </div>
                      <div className="card-body pb-0">
                        <h5 className="card-title font-600">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <Strikethrough
                              containerStyle={{
                                // padding: "0px 20px 0px 20px",
                                display: "inline-block",
                                marginLeft: "-5px",
                              }}
                              containerClass="my-1"
                              rotation="17"
                              widthAdd={15}
                              flip
                            >
                              $600
                            </Strikethrough>
                          ) : (
                            <div
                              style={{
                                display: "inline-block",
                                marginLeft: "-5px",
                              }}
                              className="my-1"
                            >
                              $600
                            </div>
                          )}
                          <br />
                          <span style={{ fontSize: "1rem" }}>
                            Monthly <br />
                            Subscription
                          </span>
                        </h5>
                        <p className="card-text pb-1">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <>
                              Your first month FREE
                              <br />
                            </>
                          ) : (
                            ""
                          )}
                          Spend less time entering data, and more time shipping.
                        </p>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleClickGetStarted}
                        >
                          Get Started
                        </button>
                        <p className="text-note mt-2 px-5">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <>
                              Standard rates apply after first month.
                              <sup>{notes.standardRates.number}</sup>
                            </>
                          ) : (
                            <div className="p-2"></div>
                          )}
                        </p>
                      </div>
                    </div>
                    <div
                      className="card paper-card cdk-card text-center border-0"
                      style={{
                        width: "20rem",
                        borderRadius: "12px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "20rem",
                          height: "13rem",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            display: "grid",
                            placeContent: "center",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1.7rem",
                            textShadow: "0px 0px 5px black",
                            backgroundColor: "rgb(0,0,0,.3)",
                            zIndex: "2",
                          }}
                        >
                          CDK Extra
                        </div>
                        <img
                          className="card-img-top"
                          src={Truck_Icon}
                          alt="A delivery truck with data, represented by circuits, flowing into it."
                          style={{
                            // transform: "translateY(0px)",
                            width: "20rem",
                            // transform: "scale(1.3) translateX(-30px)",
                            // height: "13rem",
                            // backgroundColor: "gray",
                          }}
                        />
                      </div>
                      <div className="card-body pb-0">
                        <h5 className="card-title font-600">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <Strikethrough
                              containerStyle={{
                                // padding: "0px 20px 0px 20px",
                                display: "inline-block",
                                marginLeft: "-5px",
                              }}
                              containerClass="mb-1"
                              rotation="17"
                              widthAdd={15}
                              flip
                            >
                              $1400
                            </Strikethrough>
                          ) : (
                            <div
                              style={{
                                display: "inline-block",
                                marginLeft: "-5px",
                              }}
                              className="mb-1"
                            >
                              $1400
                            </div>
                          )}
                          <br />
                          <span style={{ fontSize: "1rem" }}>
                            Monthly <br />
                            Subscription
                          </span>
                        </h5>
                        <div className="card-text pb-2 border-bottom">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <>
                              Your first month FREE
                              <br />
                            </>
                          ) : (
                            ""
                          )}
                          Everything in the base plan plus the ability to view
                          and ship your open orders.
                        </div>
                        <div className="card-text py-2 border-bottom font-small text-note">
                          Closed + Open Orders
                        </div>
                        <p className="card-text py-2 border-bottom font-small text-note">
                          First 30k open order transactions included <br />
                          $0.06 per transaction after.
                        </p>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleClickGetStarted}
                        >
                          Get Started
                        </button>
                        <p className="text-note mt-2 px-5">
                          {isEligibleForCDKTrial(cdkSubscriptionStatus) ? (
                            <>
                              Standard rates apply after first month.
                              <sup>{notes.standardRates.number}</sup>
                            </>
                          ) : (
                            <div className="p-2"></div>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {design === 4 && (
                  <div
                    className="card paper-card text-center border-0"
                    style={{
                      // width: "20rem",
                      borderRadius: "12px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          width: "20rem",
                          height: "13rem",
                          overflow: "hidden",
                        }}
                        className="list-border-bottom"
                      >
                        <img
                          className="card-img-top"
                          src={Truck_Icon}
                          alt="A delivery truck with data, represented by circuits, flowing into it."
                          style={{
                            // transform: "translateY(0px)",
                            width: "20rem",
                            // height: "13rem",
                            // backgroundColor: "gray",
                          }}
                        />
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="cdk-pricing-chart-header list-border-bottom cdk-pricing-chart-cell"
                      >
                        Base Charge Per Month
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="cdk-pricing-chart-header list-border-bottom cdk-pricing-chart-cell"
                      >
                        Transactions Covered
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="cdk-pricing-chart-header list-border-bottom cdk-pricing-chart-cell"
                      >
                        Additional Transaction Charge
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="cdk-pricing-chart-header list-border-bottom cdk-pricing-chart-cell"
                      >
                        Who it's for
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="cdk-pricing-chart-header cdk-pricing-chart-cell"
                      >
                        What counts as a transaction?
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          height: "13rem",
                          width: "18rem",
                          padding: "2rem",
                          display: "grid",
                          placeContent: "center",
                        }}
                        className="cdk-pricing-chart-header list-border-bottom"
                      >
                        Retrieve Closed Orders
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="list-border-bottom cdk-pricing-chart-cell"
                      >
                        $600
                      </div>
                      <div style={{ padding: "2rem" }}>
                        If you want to find your orders in our system once you
                        close them in yours, without having to re-enter
                        everything!
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          height: "13rem",
                          padding: "2rem",
                          display: "grid",
                          placeContent: "center",
                        }}
                        className="cdk-pricing-chart-header list-border-bottom"
                      >
                        Retrieve Open Orders
                      </div>
                      <div
                        style={{ padding: "2rem" }}
                        className="list-border-bottom cdk-pricing-chart-cell"
                      >
                        $1400
                      </div>
                      <div style={{ padding: "2rem" }}>
                        If you need your orders in our system before they are
                        closed in yours, such as in the case your business does
                        not close COD orders until after delivery and payment is
                        received.
                      </div>
                    </div>
                  </div>
                )}
              </SimpleTransitionBoth>
            </div>
          </div>
          {/* <TermsAgreementModal
            show={showTermsModal}
            onHide={handleCloseTermsModal}
            url={basePath + pdfLinks.termsAndConditionsLogin}
          /> */}
        </section>

        <section className="p-3 p-md-5 bg-dil-blue text-light">
          <SimpleTransitionBoth
            delay={everythingElseDelay}
            duration={everythingElseDuration}
            transitionBaseClass="px-3"
            transitionBaseStyle={{
              opacity: 0,
              transform: "translateY(30px)",
            }}
            transitionEndStyle={{
              opacity: 1,
              transform: "translateY(0px)",
            }}
          >
            <SimpleTransitionBoth
              transitionBaseClass="py-2" //used just for styling here
              duration="1s"
              triggerOnScroll={true}
              triggerOnScrollObserverOptions={{
                rootMargin: "0px 0px 0% 0px",
              }}
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateX(-30px)",
              }}
              transitionEndStyle={{
                opacity: 1,
                transform: "translateX(0px)",
              }}
            >
              <h3>Ship Faster</h3>
              <p>
                Save time with the new CDK integration. You'll place your orders
                in your system. But instead of having to re-enter them in our
                portal, they will be automatically uploaded to our system.
                <br /> All you have to do is validate the information and
                finalize your orders.
              </p>
            </SimpleTransitionBoth>
            <SimpleTransitionBoth
              transitionBaseClass="py-2" //used just for styling here
              duration="1s"
              triggerOnScroll={true}
              triggerOnScrollObserverOptions={{
                rootMargin: "0px 0px -20% 0px",
              }}
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateX(-30px)",
              }}
              transitionEndStyle={{
                opacity: 1,
                transform: "translateX(0px)",
              }}
            >
              <h3>Filter Based on Your Preference</h3>
              <p>
                Choose which orders to import using the CDK ShipVia field.
                <sup>{notes.sharing.number}</sup>
              </p>
            </SimpleTransitionBoth>
            <SimpleTransitionBoth
              transitionBaseClass="py-2" //used just for styling here
              duration="1s"
              triggerOnScroll={true}
              triggerOnScrollObserverOptions={{
                rootMargin: "0px 0px -30% 0px",
              }}
              transitionBaseStyle={{
                opacity: 0,
                transform: "translateX(-30px)",
              }}
              transitionEndStyle={{
                opacity: 1,
                transform: "translateX(0px)",
              }}
            >
              <h3>View Orders Anytime</h3>
              <p>
                View which orders you've placed through the CDK integration
                effortlessly, right through the order history page with the new
                Via filter.
              </p>
            </SimpleTransitionBoth>
            <div className="pb-5 pt-3">
              <div className="text-center pt-5">
                <h3 className="font-400" style={{ letterSpacing: "3px" }}>
                  Frequently Asked Questions
                </h3>
              </div>
              <div className="text-dark pb-3">
                <FAQAccordion faqs={CDKFAQs} />
              </div>
              {/* {CDKFAQs.map((FAQ, index) => {
              return (
                <div key={index}>
                  <div>{FAQ.question}</div>
                  <div>{FAQ.answer}</div>
                </div>
              );
            })} */}
            </div>
          </SimpleTransitionBoth>
        </section>
        {/* {console.log(notesCount)} */}
        <section className="py-4 bg-dil-red px-3">
          <div className="px-0 px-md-5 text-light">
            {Object.values(notes).map((note) => {
              return (
                <div
                  key={note.number}
                  className="font-small"
                  style={{ color: "rgb(240,240,240)" }}
                >
                  {note.number}. {note.explanation}
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </>
  );
};
